import { Component, OnInit, ViewChild } from '@angular/core';
import { TimelineService } from 'src/app/services/timeline.service';
import { ModalController, Platform } from '@ionic/angular';
import { ZoneDataManagerService } from 'src/app/services/zone-data-manager.service';
//import * as Phaser from '@ion-phaser/core';

declare var Phaser;

@Component({
  selector: 'app-roza-wiatrow',
  templateUrl: './roza-wiatrow.page.html',
  styleUrls: ['./roza-wiatrow.page.scss'],
})
export class RozaWiatrowPage implements OnInit {

  //@ViewChild('imageCanvas', { static: false }) canvas: any;
  //canvasElement: any;
  chosenLocation = 'x';
  chosenDirection = 'x';
  initialize = true;
  

  game = {
    width: "100%",
    height: 300,
    type: 'AUTO',
    scene: BootScene,
    instance: null
  }

  constructor(private zoneDataManager:ZoneDataManagerService, private plt: Platform, private modalCtrl:ModalController, public timeline:TimelineService) { }

  ngOnInit() {
    console.log('init roza', this.timeline.currentDirections, this.zoneDataManager.currentLocation)
    localStorage.setItem('location', JSON.stringify(this.zoneDataManager.currentLocation));

    this.timeline.startMoveFromLocation = this.zoneDataManager.currentLocation;
  }


  initializeGame () {
    this.initialize = true;
  }

  getInstance () {
    return this.game.instance;
  }

  changeAngle () {
    const instance = this.getInstance();
    instance.scene.scenes.forEach(scene => {
      if (scene.sys.isActive() && scene instanceof CommonScene) {
        //scene.setAngle(0);
        console.log('change angle', scene)
      }
    });
  }

  ngAfterViewInit() {

    //this.initializeGame();
    // Set the Canvas Element and its size
    //this.canvasElement = this.canvas.nativeElement;
    //this.canvasElement.width = this.plt.width() - 10;
    //this.canvasElement.height = 400;

    //this.setBackground();
    //console.log('rect', this.canvasElement.getBoundingClientRect())
/*
    let config = {
        type: Phaser.AUTO,
        parent: this.canvasElement,
        height: 600,
        width: 800,
        scene: [ GameScene ],
        physics: {
          default: 'arcade',
          arcade: {
            gravity: { y: 100 }
          }
        }
    };

  this.game = new Phaser.Game(config);
  this.create();
  
  
  }

  preload ()
  {
      this.load.image('map', 'assets/images/map.jpg');
  }

create ()
{
  const sceneConfig = {
    active: false,
    visible: false,
    key: 'Game',
  };

*/
/*
    this.cameras.main.setBounds(0, 0, 1024, 2048);
    
    this.add.image(0, 0, 'map').setOrigin(0);

    this.cameras.main.setZoom(1);
    this.cameras.main.centerOn(0, 0);

    

    var pos = 0;

    
    this.input.on('pointerdown', function () {

        var cam = this.cameras.main;

        if (pos === 0)
        {
            cam.pan(767, 1096, 2000, 'Power2');
            cam.zoomTo(4, 3000);
            pos++;
        }
        else if (pos === 1)
        {
            cam.pan(703, 1621, 2000, 'Elastic');
            cam.zoomTo(2, 3000);
            pos++;
        }
        else if (pos === 2)
        {
            cam.pan(256, 623, 2000, 'Sine.easeInOut');
            cam.zoomTo(1, 3000);
            pos++;
        }
        else if (pos === 3)
        {
            cam.pan(166, 304, 2000);
            cam.zoomTo(4, 1500);
            pos++;
        }
        else if (pos === 4)
        {
            cam.pan(624, 158, 2000);
            cam.zoomTo(0.5, 3000);
            pos++;
        }
        else if (pos === 5)
        {
            cam.pan(680, 330, 2000);
            pos++;
        }
        else if (pos === 6)
        {
            cam.pan(748, 488, 2000);
            pos++;
        }
        else if (pos === 7)
        {
            cam.pan(1003, 1719, 2000);
            pos = 0;
        }

    }, this);
    */
}



  goTo(dire)
  {
    
    if(dire=='N')
    {
      this.chosenLocation = this.timeline.currentDirectionsLocations[0]
      this.chosenDirection = 'N';
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[0])
    }
    else if(dire=='NE')
    {
      this.chosenDirection = 'NE';
      this.chosenLocation = this.timeline.currentDirectionsLocations[1]
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[1])
    }
    else if(dire=='E')
    {
      this.chosenDirection = 'E';
      this.chosenLocation = this.timeline.currentDirectionsLocations[2]
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[2])
    }
    else if(dire=='SE')
    {
      this.chosenDirection = 'SE';
      this.chosenLocation = this.timeline.currentDirectionsLocations[3]
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[3])
    }
    else if(dire=='S')
    {
      this.chosenDirection = 'S';
      this.chosenLocation = this.timeline.currentDirectionsLocations[4]
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[4])
    }
    else if(dire=='SW')
    {
      this.chosenDirection = 'SW';
      this.chosenLocation = this.timeline.currentDirectionsLocations[5]
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[5])
    }
    else if(dire=='W')
    {
      this.chosenDirection = 'W';
      this.chosenLocation = this.timeline.currentDirectionsLocations[6]
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[6])
    }
    else if(dire=='NW')
    {
      this.chosenDirection = 'NW';
      this.chosenLocation = this.timeline.currentDirectionsLocations[7]
      console.log('goTo ', dire,  this.timeline.currentDirectionsLocations[7])
    }


    localStorage.setItem('locationToGo', JSON.stringify(this.zoneDataManager.getLocationByID(this.chosenLocation)));

    
    this.dismiss();
  }

  dismiss() {

   
    console.log('dismiss', this.chosenLocation, this.chosenDirection);
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'chosenLocation': this.chosenLocation,
      'chosenDirection': this.chosenDirection
    });
  }
}


const SCENES = {
  FIRST: 'FirstScene',
  SECOND: 'SecondScene'
}

class CommonScene extends Phaser.Scene {

  
  helloWorld: Phaser.GameObjects.Text

  myAvatar;
  cursors

  config = {
    type: Phaser.AUTO,
    parent: 'phaser-example',
    width: "100%",
    height: 300,
    pixelArt: true,
    physics: {
        default: 'arcade',
    },
    scene: {
        preload: this.preload,
        create: this.create,
        update: this.update
    }
};



  init () {
    this.cameras.main.setBackgroundColor('#24252A');
    this.game.events.on('destroy', function() {

      console.log('destroy destroy');
    })
  }

  preload ()
  {
      this.load.image('map', 'assets/images/map.jpg');
      this.load.image('myAvatar', 'assets/images/pointer.png');
  }

  create () {


    let locationData = JSON.parse(localStorage.getItem('location'))
    console.log('locationData', locationData);

    this.cameras.main.setBounds(0, 0, 2912, 1305);
    this.cameras.main.centerOn(locationData.gpsX+160, locationData.gpsY);

    this.add.image(0, 0, 'map').setOrigin(0).setScrollFactor(1);

    this.cursors = this.input.keyboard.createCursorKeys();
    //console.log('cursors', this.cursors)

    this.myAvatar = this.add.image(locationData.gpsX, locationData.gpsY, 'myAvatar');
    this.myAvatar.setInteractive().on('pointerdown', function(pointer, localX, localY, event){
      console.log('myAvatar', pointer, localX, localY, event)
    });

    this.cameras.main.setZoom(2);
    
    
    //this.cameras.main.startFollow(this.myAvatar, true, 0.05, 0.05, 60, 0);
    //this.cameras.main.roundPixels = true;

    

    //this.cameras.main.pan(locationData.gpsX+70, locationData.gpsY, 2000, 'Power2');
    //this.cameras.main.zoomTo(2, 1000);

    //this.game.debug.cameraInfo(this.game.camera, 32, 32);
    //this.game.debug.spriteCoords(this.myAvatar, 32, 500);
    /*
    this.helloWorld = this.add.text(
      this.cameras.main.centerX, 
      this.cameras.main.centerY, 
      "Hello World", { 
        font: "40px Arial", 
        fill: "#ffffff" 
      }
    );
    this.helloWorld.setOrigin(0.5);

    this.input.keyboard.on('keyup_C', function() {
      this.scene.start(
        this.scene.key === SCENES.FIRST ?
          SCENES.SECOND : SCENES.FIRST
      );
    }, this);
    */
  }

  updateDirect ()
{
    if (this.cursors.left.isDown)
    {
        //this.myAvatar.setAngle(-90);
        this.myAvatar.x -= .2;
    }
    else if (this.cursors.right.isDown)
    {
      //this.myAvatar.setAngle(90);
      this.myAvatar.x += .2;
    }

    if (this.cursors.up.isDown)
    {
      //this.myAvatar.setAngle(0);
      this.myAvatar.y -= .2;
    }
    else if (this.cursors.down.isDown)
    {
      //this.myAvatar.setAngle(-180);
      this.myAvatar.y += .2;
    }
}
update ()
{
  this.myAvatar.setVelocity(0);

    if (this.cursors.left.isDown)
    {
      //this.myAvatar.setAngle(-90).setVelocityX(-200);
    }
    else if (this.cursors.right.isDown)
    {
      //this.myAvatar.setAngle(90).setVelocityX(200);
    }

    if (this.cursors.up.isDown)
    {
      //this.myAvatar.setAngle(0).setVelocityY(-200);
    }
    else if (this.cursors.down.isDown)
    {
      //this.myAvatar.setAngle(-180).setVelocityY(200);
    }
}
  setAngle (angle: number) {
    this.myAvatar.angle = angle;
  }
}

class FirstScene extends CommonScene {
  update () {
    this.updateDirect();
  }
}



export class BootScene extends Phaser.Scene {
  create() {
    this.scene.add(SCENES.FIRST, FirstScene, true);
    this.scene.run(SCENES.FIRST);
  }
}

interface GameInstance extends Phaser.Types.Core.GameConfig {
  instance: Phaser.Game
}
